<template>
  <div class="relative hero h-screen bg-transparent">
    <Wave class="block absolute w-full h-full" />
    <div class="hero-content relative z-10 h-4/5 flex flex-col px-5">
      <img class="w-96 block" v-if="content.logo" :src="content.logo.filename" :alt="content.title" />
      <h1 class="font-medium text-center text-4xl text-white my-6" v-html="content.title"></h1>
      <a class="bg-transparent border-2 border-solid border-white rounded-lg py-4 px-5 block text-white hover:bg-white hover:text-primary transition" :href="content.btn_anchor">{{content.btn}}</a>
    </div>
  </div>
</template>

<script>
import Wave from "@/components/Wave.vue";
import { gsap } from "gsap";
export default {
  components: {
    Wave,
  },
  props: {
    content: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    gsap.from(".hero-content > *", {
      duration: 1.1,
      opacity: 0,
      delay: 0.4,
      stagger: {
        amount: 1
      }
    });
  },
};
</script>

<style scoped>
.hero {
  max-width: 100% !important;
  width: 100% !important;
}
</style>